import { CardForm, InputEmailForm, InputPassword, InputTextForm } from '@/uiComponents/common';
import { useTranslation } from 'react-i18next';
import ChangeMailModal from './changeMailModal/changeMailModal';
import { useFormContext, useWatch } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { useUser } from '@/hooks';
import { hasAllowedRoles } from '@/helpers/roles';
import InputPhoneDelete from '@/uiComponents/common/inputs/inputPhoneDelete';

const UserInformation = ({ t, className, id, phone, mode }) => {
  const { t: translate } = useTranslation('translation', { keyPrefix: 'forms.userForm' });
  const methods = useFormContext();
  const emailField = useWatch({ name: 'email' });
  const { roles } = useUser();
  const canEditEmail = hasAllowedRoles(roles, [
    'superadministrator',
    'marketadmin',
    'email-modifier',
  ]);
  const canPhone = hasAllowedRoles(roles, ['superadministrator', 'marketadmin']);
  return (
    <>
      <CardForm title={t('userInformation.title')} className={className}>
        <div className='row tw-mb-6'>
          <InputTextForm
            name={'firstName'}
            label={t('rowPersonalInfo.inputFirstName.label')}
            placeholder={t('rowPersonalInfo.inputFirstName.placeholder')}
            isRequired={true}
            className={'col-6 '}
          />

          <InputTextForm
            name={'lastName'}
            label={t('rowPersonalInfo.inputLastName.label')}
            placeholder={t('rowPersonalInfo.inputLastName.placeholder')}
            isRequired={true}
            className={'col-6'}
          />
        </div>
        <div className='row tw-mb-6'>
          {(mode === 'PROFILE' || mode === 'USER') && !id ? (
            <InputEmailForm
              name={'email'}
              label={t('rowPersonalInfo.inputEmail.label')}
              placeholder={t('rowPersonalInfo.inputEmail.placeholder')}
              className={'col-6 tw-mb-6'}
              isRequired={true}
              isDisabled={!!id}
            />
          ) : null}

          {mode === 'CONCIERGE' ||
          ((mode === 'PROFILE' || mode === 'USER') && !!id && canEditEmail) ? (
            <div className='tw-space-y-2 col-6'>
              <Label htmlFor='email'>Email</Label>
              <div className='tw-relative'>
                <div
                  className={`tw-flex tw-h-10 tw-w-full tw-items-center tw-rounded-md tw-border tw-border-input tw-bg-muted tw-px-3 tw-py-2 tw-text-sm ${
                    !canEditEmail ? 'tw-cursor-not-allowed tw-opacity-50' : ''
                  }`}
                >
                  {emailField}
                </div>
                <ChangeMailModal
                  canEditEmail={canEditEmail}
                  setValue={methods.setValue}
                  email={emailField}
                />
              </div>
            </div>
          ) : null}

          <InputPhoneDelete
            name={'phone'}
            label={t('rowPersonalInfo.inputPhone.label')}
            placeholder={t('rowPersonalInfo.inputPhone.placeholder')}
            isRequired={false}
            className={'col-6'}
            isDisabled={!!phone || !canPhone}
            canPhone={canPhone && !!phone}
          />
        </div>
        <div className='row'>
          {!id && (
            <InputPassword
              className={'col-6'}
              name={'password'}
              label={translate('inputPass.label')}
              placeholder={''}
              autocomplete={'new-password'}
            />
          )}
        </div>
      </CardForm>
    </>
  );
};

export default UserInformation;
